/**
 * Per-browser preference for the animated Alegarta smoke background.
 * Default: on — user may turn off via the footer toggle.
 */

export const ALEGARTA_SMOKE_STORAGE_KEY = 'lsc_alegarta_smoke_enabled';
export const ALEGARTA_SMOKE_CHANGE_EVENT = 'lsc-alegarta-smoke-change';

export function readAlegartaSmokeEnabled() {
    try {
        const stored = localStorage.getItem(ALEGARTA_SMOKE_STORAGE_KEY);
        if (stored === null) {
            return true;
        }
        return stored === 'true';
    } catch {
        return true;
    }
}

export function writeAlegartaSmokeEnabled(enabled) {
    const value = Boolean(enabled);
    try {
        localStorage.setItem(ALEGARTA_SMOKE_STORAGE_KEY, value ? 'true' : 'false');
    } catch {
        /* storage blocked — still update in-memory listeners */
    }
    window.dispatchEvent(
        new CustomEvent(ALEGARTA_SMOKE_CHANGE_EVENT, { detail: value })
    );
    return value;
}
